import { Components, Theme } from "@mui/material/styles";

/**
 * Configuración de componentes Material-UI - COMPACT THEME
 * Tema compacto con UI verticalmente densa por defecto
 * PROHIBIDO usar <Grid> y <Grid2> - SOLO <Stack>
 */
export const components: Components<Theme> = {
  // Botones - tamaño small por defecto
  MuiButton: {
    defaultProps: {
      variant: "contained",
      size: "small",
    },
  },

  // Text Fields - tamaño small por defecto
  MuiTextField: {
    defaultProps: {
      size: "small",
    },
  },

  // Select - tamaño small por defecto
  MuiSelect: {
    defaultProps: {
      size: "small",
    },
  },

  // FormControl - tamaño small por defecto
  MuiFormControl: {
    defaultProps: {
      size: "small",
    },
  },

  // Chips - tamaño small por defecto
  MuiChip: {
    defaultProps: {
      size: "small",
    },
  },

  // IconButton - tamaño small por defecto
  MuiIconButton: {
    defaultProps: {
      size: "small",
    },
  },

  // Switch - tamaño small por defecto
  MuiSwitch: {
    defaultProps: {
      size: "small",
    },
  },

  // Checkbox - tamaño small por defecto
  MuiCheckbox: {
    defaultProps: {
      size: "small",
    },
  },

  // Radio - tamaño small por defecto
  MuiRadio: {
    defaultProps: {
      size: "small",
    },
  },

  // Table - dense por defecto
  MuiTable: {
    defaultProps: {
      size: "small",
    },
  },

  // TableCell - padding reducido
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: "8px 16px",
      },
      sizeSmall: {
        padding: "6px 12px",
      },
    },
  },

  // List - dense por defecto
  MuiList: {
    defaultProps: {
      dense: true,
    },
  },

  // ListItem - dense por defecto
  MuiListItem: {
    defaultProps: {
      dense: true,
    },
  },

  // Card - padding reducido
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 16,
        "&:last-child": {
          paddingBottom: 16,
        },
      },
    },
  },
};
